/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForIncorrectRequestsResponseIncorrectRequestElements,
    ReportForIncorrectRequestsResponseIncorrectRequestElementsFromJSON,
    ReportForIncorrectRequestsResponseIncorrectRequestElementsFromJSONTyped,
    ReportForIncorrectRequestsResponseIncorrectRequestElementsToJSON,
} from './ReportForIncorrectRequestsResponseIncorrectRequestElements';

/**
 * 
 * @export
 * @interface ReportForIncorrectRequestsResponse
 */
export interface ReportForIncorrectRequestsResponse {
    /**
     * 
     * @type {Array<ReportForIncorrectRequestsResponseIncorrectRequestElements>}
     * @memberof ReportForIncorrectRequestsResponse
     */
    incorrectRequestElements: Array<ReportForIncorrectRequestsResponseIncorrectRequestElements>;
    /**
     * 
     * @type {number}
     * @memberof ReportForIncorrectRequestsResponse
     */
    incorrectRequestTotalElementCount: number | null;
}

export function ReportForIncorrectRequestsResponseFromJSON(json: any): ReportForIncorrectRequestsResponse {
    return ReportForIncorrectRequestsResponseFromJSONTyped(json, false);
}

export function ReportForIncorrectRequestsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForIncorrectRequestsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'incorrectRequestElements': ((json['incorrectRequestElements'] as Array<any>).map(ReportForIncorrectRequestsResponseIncorrectRequestElementsFromJSON)),
        'incorrectRequestTotalElementCount': json['incorrectRequestTotalElementCount'],
    };
}

export function ReportForIncorrectRequestsResponseToJSON(value?: ReportForIncorrectRequestsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'incorrectRequestElements': ((value.incorrectRequestElements as Array<any>).map(ReportForIncorrectRequestsResponseIncorrectRequestElementsToJSON)),
        'incorrectRequestTotalElementCount': value.incorrectRequestTotalElementCount,
    };
}

